<template>
    <div>
        <LoadingScreen v-if="isLoadingScreen" />
        <div class="sport" v-else>
            <div class="sport__header">
                <div class="sport_home" @click="onBackToHome">
                    <span class="chevron"></span>
                    <span class="sport_text">{{ getTranslatedText('home') }}</span>
                </div>
                <span class="sport_text sports">{{ getTranslatedText('sports') }}</span>
            </div>
            <div class="sport__iframe">
                <iframe id="sport-cms-retail" :src="iframeUrl" scrolling="yes"></iframe>
            </div>
        </div>
        <Reprint/>
    </div>
</template>

<script>
import LoadingScreen from '@/components/common/loading/loading.vue';
import languageMixins from '@/mixins/language-mixins';
import utilsMixin from '@/mixins/function-utils';
import printMixins from '@/mixins/print-mixins';
import EventBus from '@/utils/EventBus';
import Reprint from '@/components/common/dialog/reprint.vue';

export default {
    mixins: [languageMixins, utilsMixin, printMixins],
    components: { LoadingScreen, Reprint },
    data() {
        return {
            isLoadingScreen: false,
            iframeUrl: '',
        };
    },
    mounted() {
        this.renderIframe();
        window.addEventListener('message', this.handleIframeMessage);
    },
    unmounted() {
        window.removeEventListener('message', this.handleIframeMessage);
    },
    methods: {
        showReprintDialog(reference, paramPrint) {
            EventBus.emit('on-show-reprint', {
                ticketType: 'S',
                reference: reference,
                betslipId: reference.startsWith('S-') ? reference : 'S-' + reference,
                paramPrint: paramPrint,
                forSport: true,
            });
        },

        handleIframeMessage(event) {
            if (event.data.type === 'cashout' && event.data.action === 'print') {
                this.printSports(event.data.data);
                this.showReprintDialog(JSON.parse(event.data.data)[0].transactions[0].id, event.data.data);
            }
        },

        renderIframe() {
            const setting = this.$store.state.configDevice;
            const setup = this.$store.state.config.setup;
            const token = this.$store.state.token;
            const lang = this.$store.state.lang;
            if (setup.isTestingBrowers && this.isObjEmpty(setting)) {
                this.iframeUrl = `${
                    setup.apiUrl
                }/retail/sport-page-for-pos/index?locale=${lang}&admin_jwt=${token}&t=${Date.now()}&app_version=browser.1&toggleTournaments=false&isScroll=true`;
            } else {
                if (!this.isObjEmpty(setting)) {
                    if (!setting.position) setting.position = {}
                    setting.position.error_message = setting.location_error
                    const p = JSON.stringify(setting.position)

                    this.iframeUrl = `${
                        setup.apiUrl
                    }/retail/sport-page-for-pos/index?locale=${lang}&admin_jwt=${token}&t=${Date.now()}&device_network_mac_address=${
                        setting.mac
                    }&app_version=${setting.appVersion}&device_serial_number=${setting.serial}&device_unique_id=${
                        setting.uniqueId
                    }&toggleTournaments=false&isScroll=true&position=${p}`;
                }
            }
        },

        onBackToHome() {
            const query = this.$route.query;
            this.$router.push({ path: '/', query });
        },
    },
};
</script>

<style lang="scss">
@import '@/public/scss/sports/sports.scss';
</style>
